import { Injectable, Type } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { DashboardResponsiveApiModelSparse } from 'src/shared/models/dashboard.model';

@Injectable({
    providedIn: 'root'
})
export class ShareViaUrlService {

    private modalData: ShareViaURLOptions = null;

    constructor(
        private cvApiService: CVApiService,
        private modalService: NgbModal,
    ) { }

    public openModal(options: ShareViaURLOptions, modalComponent: Type<any>): NgbModalRef {
        if (!options || typeof options !== 'object') throw 'Options argument is required';

        this.modalData = options;

        const modalRef = this.modalService.open(modalComponent, {
            backdrop: 'static',
            keyboard: false,
            size: '500',
            centered: true,
        });

        return modalRef;
    }

    public async generateSharedKey() {
        try {
            const url = `/api/v2/GenerateNewSharedKey`
            const response = await this.cvApiService.get<string>(url);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } else {
                throw response;
            }
        } catch (error) {
            console.error('Failed generating share key');
            throw error;
        }
    }

    public async modifyDashboardSharedViaURL(dashboard: DashboardResponsiveApiModelSparse) {
        try {
            const url = `/api/v2/ModifyDashboardSharedViaURL`;
            const options = `?dashboardID=${dashboard.DashboardID}&isSharedURL=${dashboard.IsSharedURL}&sharedKey=${dashboard.SharedKey}`;
            this.cvApiService.put(url + options);
        } catch (error) {
            console.error('Failed modifying dashboard shared via URL');
            throw error;
        }
    }

    public _getModalData(): ShareViaURLOptions {
        const modalData = this.modalData;
        this.modalData = null;
        return modalData;
    }
}

export interface ShareViaURLOptions {
    dashboard: DashboardResponsiveApiModelSparse;
}
